import { Col, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { INSTALLMENT_KYMDAN } from "../../../common/constant";
import { checkSpecialMattress, getDiscountName } from "../../../shared/helpers";
import "./style.scss";

const ProductPrice = (props: any) => {
  const { productInfo } = props;
  const { t } = useTranslation();

  return (
    <Row
      align="middle"
      justify="center"
      className="product-information-price-wrapper">
      <Col span="24">
        <Row
          align="middle"
          // justify="center"
          className="product-information-price-item-wrapper"
          // gutter={4}
        >
          <Col
            // flex={1}
            lg={12}
            sm={14}
            xs={14}>
            <Row align="middle" style={{ flexWrap: "nowrap" }}>
              <Col
                flex="auto"
                className="main-title price-value price-promotion">
                {productInfo.price_promotion}
              </Col>
              <Col className="currency-unit-wrap">
                {t("label_currency_unit")}
              </Col>
            </Row>
          </Col>
          <Col className="sub-title price-title">
            <span className="discount-percent">
              {getDiscountName(
                productInfo.price,
                productInfo.price_promotion,
                productInfo.discount_percent
              )}
            </span>
          </Col>
          {/* <Col className="sub-title price-title">{t("label_price")}</Col> */}
        </Row>
        {!checkSpecialMattress(
          productInfo.price,
          productInfo.price_promotion
        ) && (
          <Row
            align="middle"
            // justify="center"
            className="product-information-price-item-wrapper">
            <Col
              // flex={1}
              lg={12}
              sm={14}
              xs={14}>
              <Row align="middle" style={{ flexWrap: "nowrap" }}>
                <Col flex="auto" className="sub-title price-value price-retail">
                  {productInfo.price}
                </Col>
                <Col className="currency-unit-wrap">
                  {t("label_currency_unit")}
                </Col>
              </Row>
            </Col>
          </Row>
        )}
        <Row className="product-information-divider"></Row>

        {productInfo.price_installment !== 0 ? (
          <Row
            align="middle"
            // justify="center"
            className="product-information-price-item-wrapper">
            <Col
              // flex={1}
              lg={12}
              sm={14}
              xs={14}>
              <Row align="middle" style={{ flexWrap: "nowrap" }}>
                <Col
                  flex="auto"
                  className="main-title price-value price-installment ">
                  {productInfo.price_installment}
                </Col>
                <Col className="currency-unit-wrap">{`${t(
                  "label_currency_unit"
                )} /${t("label_month_unit")}`}</Col>
              </Row>
            </Col>
            <Col
              //  span={10}
              className="price-title price-installment-title">
              <div className="price-installment-title-wrap">
                <a href={INSTALLMENT_KYMDAN} target="_blank" className="">
                  {t("label_installment")}
                </a>
                <span className="sub-content gift-more">
                  {t("label_more_gifts")}
                </span>
              </div>
            </Col>
          </Row>
        ) : null}
        {/* <Row
          align="middle"
          justify="end"
          className="product-information-price-item-wrapper">
          <Col className="sub-content gift-more">{t("label_more_gifts")}</Col>
        </Row> */}
      </Col>
    </Row>
  );
};

export default ProductPrice;
